import React from 'react';

// components
import ListTable from '../../../elements/lists/ListTable';
import SimplePageSelector from  '@/components/elements/global/PageSelectors/SimplePageSelector';
import SortByContentDropdown from  '@/components/elements/global/dropdown/SortByContentDropdown';
import WidgetPanelList from  '@/components/page/widgetsPanel/WidgetPanelListScreen';
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton';
import Information from  '@/components/elements/global/Information';
import NotificationBar from  '@/components/elements/languages/NotificationBar';

//hooks
import UseListScreen from './ContentList.hooks';

// utility and constants
import {AddNewContentButtonContent, SavingListAsDraft} from  '@/components/elements/lists/ListConstants';

//styling
import  '@/css/lists/list.scss';



const ContentList = () => {
    const {menuItems, sortType, setSortType, updateListContentItems, paginationSettings, hasEditorRights, widgetPanelOpen, setWidgetPanelOpen, savingContent, listTitleError, notificationDetails, isCombinedFeedEnabled} = UseListScreen();

    return (<>
        <div className="home-screen-container" data-testid="content-list">
            {listTitleError &&  <Information text={'You cannot add content to an untitled list'} style={undefined} />}
            <div className='main-menu-title-wrapper'>
                <SortByContentDropdown currentSortType={sortType} setSortType={setSortType} />
                
                {hasEditorRights &&   
                        <BasicButton 
                            content={savingContent ? <SavingListAsDraft /> : <AddNewContentButtonContent isOpen={widgetPanelOpen}/> }
                            ariaLabel={widgetPanelOpen ? 'Close widget panel' : 'Add New Content'}
                            onButtonClick={() => setWidgetPanelOpen(!widgetPanelOpen)} className='add-new-content-button'
                            isDisabled={savingContent}
                        />
                    // :   <div className="table-filters"><ViewToggleDropdown className='toggle-dropdown' viewOption={viewOption} setViewOption={setViewOption} buttonContent={<ViewOptionButtonPlaceHolder viewOption={viewOption} />}  buttonAriaLabel={viewOptionAriaLabel(viewOption)} /></div>
                }
            </div>
            
            <WidgetPanelList className={widgetPanelOpen? 'widget-panel-is-open' : 'widget-panel-is-closed'} isCombinedFeedEnabled={isCombinedFeedEnabled}/>
        
            <ListTable menuItems={menuItems} sortType={sortType} paginationOptions={paginationSettings}/>

            {paginationSettings?.hasPagination && 
                <div className='page-selector-wrapper'>
                    <SimplePageSelector
                        currentPage={paginationSettings.currentPage}
                        totalPages={paginationSettings.totalPages}
                        setPage={(page) => {updateListContentItems(page)}}
                    />
                </div>
            }
        </div>

        <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails.status} msg={notificationDetails.message} />
    </>)
}

export default ContentList